import 'rxjs';
import { Observable } from 'rxjs/Observable';
import actions, { LOAD_UNALLOCATED_FREELANCERS } from '../actions';

const loadUnallocatedFreelancersEpic = (action$, store, { api }) =>
    action$.ofType(LOAD_UNALLOCATED_FREELANCERS).mergeMap(action =>
        Observable.from(api.fetchUnallocatedFreelancers(action.payload))
            .map(response => actions.loadUnallocatedFreelancerSuccess(response.data))
            .catch(() =>
                Observable.of(
                    actions.loadUnallocatedFreelancerFailure(
                        'Problem loading unallocated freelancers',
                    ),
                ),
            ),
    );

export default loadUnallocatedFreelancersEpic;
